module.exports = __webpack_public_path__ + "static/media/tablet-alt.4338cd0d.svg";